

import {
  sendMsgSms, validMsg, toggleNotify, checkNotify
} from '@/zsm-api-new/sms.js'
import { getTemplate, templateListData, labelListData, classifyListData, settingConfig, ossUploadToken, settingDict, refreshToken } from '@/zsm-api-new/dict.js'
import {
  saveLocalStorage,
  getLocalStorageObject
} from '@/utils/auth.js'
const state = {
  feedbackVisible: false,// 反馈弹框是否显示
  APPID: 'wx6dc93737b8443b41',
  kuaishouBaseUrl: 'https://kittyhow.com/kuaishou',
  kuaishouBaseUrlCss: 'https://kittyhow.com/kuaishou.css',
  bindDistWechatUrl: 'https://kittyhow.com/weixin', //默认初始化达人进入页面
  authWarnTit: '您没有权限查看或修改该商品', //全局警告提示
  systemReqError: '系统维护中，请稍后登陆', //系统请求错误时提示
  examplesModal: false,//预览的弹框是否展示
  mediaUrl3: '',//预览的音频
  examplesImage: '',//预览的图片
  mediaUrl: '',//预览的视频

}

const mutations = {

}

const actions = {
  // 切换是否收短信
  toggleNotify({ commit }, mobile) {
    return new Promise((resolve, reject) => {
      toggleNotify(mobile).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 检查是否收短信
  checkNotify({ commit }, mobile) {
    return new Promise((resolve, reject) => {
      checkNotify(mobile).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 查看模板列表
  templateListData({
    commit
  }) {
    return new Promise((resolve, reject) => {
      templateListData().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 查看一个模板
  getTemplate({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      getTemplate(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取标签列表
  labelListData({
    commit
  }) {
    return new Promise((resolve, reject) => {
      labelListData().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取课程分类
  classifyListData({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      classifyListData(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 验证验证码
  validMsg({ commit }, info) {
    return new Promise((resolve, reject) => {
      validMsg(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 发送验证码
  sendMsgSms({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      const { mobile, msgDict } = info
      sendMsgSms(mobile, msgDict).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 刷新阿里云上传文件的token
  refreshToken({
    commit
  }, videoId) {
    return new Promise((resolve, reject) => {
      refreshToken(videoId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取七牛云上传文件的token
  ossUploadToken({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      const { filePath, title } = info
      ossUploadToken(filePath, title).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 字典管理-获取某个字典的所有值的集合
  settingDict({
    commit
  }, dictType) {
    // 预览内容
    let previewValue;
    if (dictType.indexOf('=') != -1) {
      previewValue = dictType.split('=')[1];
      dictType = dictType.split('=')[0]
    }
    return new Promise(async (resolve, reject) => {
      let response = { data: [] }
      if (dictType == 'zsm_upload_pc_course_tutorial') {
        if (getLocalStorageObject('zsm_upload_pc_course_tutorial')) {
          response.data = getLocalStorageObject('zsm_upload_pc_course_tutorial')
        } else {
          response = await settingDict(dictType);
          saveLocalStorage('zsm_upload_pc_course_tutorial', response.data)
        }
        if (dictType == 'zsm_upload_pc_course_tutorial' && previewValue) {
          let filterData = response.data.filter(item => item.dictValue == previewValue)[0]
          if (filterData && filterData.description) {
            // 打开新页面
            window.open(filterData.description, '_black')
          } else {
            setTimeout(() => {
              // 打开全局预览图
              state.examplesImage = filterData.remarks
              state.examplesModal = true
            }, 200);
          }
        }

      } else {
        response = await settingDict(dictType);
      }
      resolve(response.data)
    }).catch(error => {
      console.error(error)
      reject(error)
    })
  },

  /* 参数设置-获取特定key对应的value */
  settingConfig({
    commit
  }, dictType) {
    return new Promise((resolve, reject) => {
      settingConfig(dictType).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }

  /* //  获取后台配置字典
  getByDictValueList({
    commit
  }, dictValue) {
    return new Promise((resolve, reject) => {
      getByDictValue(dictValue).then(response => {
        if (response.data) {
          resolve(response.data)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //  获取后台配置字典
  getValueInfo({
    commit
  }, dictValue) {
    return new Promise((resolve, reject) => {
      getValue(dictValue).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getConfigValueInfo({
    commit
  }, dictValue) {
    return new Promise((resolve, reject) => {
      getConfigValue(dictValue).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  } */
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
